import * as Yup from 'yup'

export const validationSchema = (messages: Record<string, string>) =>
  Yup.object().shape({
    address: Yup.object()
      .shape({
        city: Yup.string().required(messages.city),
        country: Yup.string().required(messages.country),
        postalCode: Yup.string().required(messages.postalCode),
        street: Yup.string().required(messages.street),
        streetNr: Yup.string().required(messages.streetNr),
      })
      .typeError('You must select an option!'),
    name: Yup.string().required(messages.name),
  })
